import React, {ReactNode} from "react";
import {withTranslation} from "react-i18next";
import {withHostApi} from "../../contexts/HostApiContext";
import {colorData} from "./iColorData";
import SearchColorBrand from "./SearchColorBrand";
import CmjnPicker from "./CmjnPicker";
import Modal from "react-responsive-modal";
import {PhotoshopPicker} from "react-color";
import SelectTextileColor from "./SelectTextileColor";
import {getShopInfosInStorage} from "tunnel-commande/src/components/cart/ShopInfos";
import axios from "axios";
import {getRequestConfig, request} from "tunnel-commande/src/utils";

interface ColorsTextileProps {
  typeTransfer: string;
  hostApi: string;
  setColorsData: any;
  lng: string;
  t: (arg0: string) => ReactNode;
}

interface ColorsTextileState {
  c?: number;
  m?: number;
  j?: number;
  n?: number;
  colorPickerValue: string;
  colorPickerValueSet: string;
  colorPickerValuesSet: any;
  colorPickerValues: any;
  displayColorPicker: boolean;
  colorData?: colorData;
  selectedFromPickr: boolean;
  changeColorSericoatWTxt: string;
  changeColorSericoatCEtxt: string;
  showWhiteTransferModale: boolean;
  showCETransferModale: boolean;
  brandColorIsOpac:boolean;
}

class ColorsTextile extends React.Component<ColorsTextileProps, ColorsTextileState> {
  private luminositeCouleurTextile: number | null = null;

  constructor(props: ColorsTextileProps) {
    super(props);
    this.state = {
      displayColorPicker: false,
      colorPickerValue: this.props.typeTransfer === 'w' ? '#fff' : '#000',
      colorPickerValues: {},
      colorPickerValuesSet: {},
      colorPickerValueSet: this.props.typeTransfer === 'w' ? '#fff' : '#000',
      selectedFromPickr: false,
      showWhiteTransferModale: false,
      showCETransferModale: false,
      changeColorSericoatWTxt: '',
      changeColorSericoatCEtxt: '',
      brandColorIsOpac: true,
      c:  0,
      m:  0,
      j:  0,
      n:  this.props.typeTransfer === 'w' ? 0 : 100,
    };

    this.luminositeCouleurTextile = getShopInfosInStorage() ? getShopInfosInStorage().luminosite_couleur_textile : 0.924;
    this.submitHandleChangeColors = this.submitHandleChangeColors.bind(this);
    this.receiveColorData = this.receiveColorData.bind(this);
    this.showWhiteTransferModale = this.showWhiteTransferModale.bind(this);
  }
  componentDidMount() {
    this.loadHtml(this.props.lng, 'changement-couleur-sericoat-w');
    this.loadHtml(this.props.lng, 'changement-couleur-sericoat-ce');
    this.luminositeCouleurTextile = getShopInfosInStorage() ? getShopInfosInStorage().luminosite_couleur_textile : 0.924;
  }

  private receiveColorData(colorData: colorData) {
    const brandColorIsNotOpac = colorData && typeof colorData.id !== 'undefined';
    if(this.props.typeTransfer === 'ce' && colorData.hsl?.l >=Number(this.luminositeCouleurTextile)) {
      this.setState({ showCETransferModale: !this.state.showCETransferModale });
    } else {
      this.props.setColorsData(colorData);
      this.setState({
        colorData: colorData, brandColorIsOpac: !brandColorIsNotOpac , colorPickerValueSet: `#${colorData?.hexadecimal}`, colorPickerValue:`#${colorData?.hexadecimal}`,selectedFromPickr:false
      });
    }
  }

  private showWhiteTransferModale(show: boolean){
    if(show) {
      if(this.props.typeTransfer === 'w') {
        this.setState({showWhiteTransferModale: show});
      } else {
        this.setState({showCETransferModale: show});
      }
    }
  }

  private loadHtml(lng: string, namePage: string) {
    axios.get(`${window.location.origin}/html/${lng}/${namePage}.html`)
      .then((res) => {
        const content = res.data;
        if(namePage === 'changement-couleur-sericoat-w') {
          this.setState({changeColorSericoatWTxt: content});
        } else if(namePage === 'changement-couleur-sericoat-ce') {
          this.setState({changeColorSericoatCEtxt: content});
        }
      }).catch((err) => {
      console.error(err);
    });
  }

  private submitHandleChangeColors(){
    if(this.props.typeTransfer === 'ce' && this.state.colorPickerValues && this.state.colorPickerValues?.hsl?.l >=Number(this.luminositeCouleurTextile)) {
      this.setState({ showCETransferModale: !this.state.showCETransferModale, displayColorPicker: false});
    } else {
      if (this.state.colorPickerValue && this.state.colorPickerValueSet != this.state.colorPickerValue) {

        this.setState({
          colorPickerValueSet: this.state.colorPickerValue,
          colorPickerValuesSet: this.state.colorPickerValues,
          selectedFromPickr: true
        }, () => {
          const hexa = this.state.colorPickerValue.replace('#','');
          this.fetchCmjn(hexa);
        });
      }
      this.setDisplayColorPicker(false);
    }
  }

  private setDisplayColorPicker(show: boolean){
    if(this.props.typeTransfer === "w" && show) {
      this.setState({showWhiteTransferModale: show});
    } else {
      this.setState({displayColorPicker: show});
    }
  }

  private fetchCmjn(hexadecimal: string) {
    request("GET", `${this.props.hostApi}/colors-class/cmjn?hexadecimal=${hexadecimal}`, {
      ...getRequestConfig()
    }).then((res) => {
      this.setState({
        colorData: {id: undefined, hsl: undefined, marqueId: 0, couleur_libelle: undefined, c: res.data.c, m: res.data.m, j: res.data.j, n: res.data.n, hexadecimal: hexadecimal}
      });
    }).catch((error) => {
      console.log(error);
    });
  }

  private handleChangeColors(color: any){
    if(color && color.hex) {
      this.setState({colorPickerValue: color.hex, colorPickerValues: color});
    }
  }

  render() {

    return (
      <>
        <div className={'bold  border-black border-bottom my-2 mt-4  '}>{this.props.t('fabric_color')}</div>
        <div className={'d-flex my-2 py-1 flex-wrap flex-md-nowrap'}>
          {this.props.typeTransfer === 'ce' &&
            <CmjnPicker selectedFromPickr={this.state.selectedFromPickr} colorData={this.receiveColorData} typeTransfer={this.props.typeTransfer} colorHexa={this.state.colorPickerValueSet}
                                                     c={this.state.colorData?.c} m={this.state.colorData?.m} j={this.state.colorData?.j} n={this.state.colorData?.n}/>
          }
          <div className={'d-flex flex-column mt-2 mt-md-0 '}>
            <div className={` ${!this.state.brandColorIsOpac ? '' : 'colorSearchSecondChoice'}`}>
              <SearchColorBrand colorData={this.receiveColorData} marqueId={this.state.colorData?.marqueId} typeTransfer={this.props.typeTransfer} luminositeCouleurTextile={Number(this.luminositeCouleurTextile)}/>
            </div>
            {this.props.typeTransfer === 'ce' &&
              <div className={'colorSearchSecondChoice'}>
                <button className={''}  onClick={() => { this.setDisplayColorPicker(true)}}>
                          <span className={`${this.props.typeTransfer === 'ce'  ? ' miniPicker ' : ''} d-flex align-items-center`}>
                            <span className={"mr-2 d-block flex-grow-1"} style={{backgroundColor: this.state.colorPickerValueSet, width: '50px'}}>&nbsp;</span>
                            <span className={"my-2 pl-2"}>
                              {this.props.typeTransfer === 'ce'  ? (
                                <>{this.props.t('find_a_matching_color')}</>
                              ) : (
                                <>{this.props.t('change')}</>
                              )}
                            </span>
                          </span>
                </button>
              </div>
            }
            {this.state.displayColorPicker &&
              <div style={{position: 'absolute', zIndex: 2, right: '0px'}}>
                <PhotoshopPicker color={this.state.colorPickerValue}
                                 onChangeComplete={color => this.handleChangeColors(color)}
                                 onAccept={this.submitHandleChangeColors} onCancel={() => {
                  this.setDisplayColorPicker(false);
                }}/>
              </div>
            }
          </div>
          {(this.props.typeTransfer === 'c' || this.props.typeTransfer === 'w') &&
            <SelectTextileColor typeTransfer={this.props.typeTransfer} showWhiteTransferModale={this.showWhiteTransferModale} />
          }
          <Modal onClose={() => {this.setState({showWhiteTransferModale: !this.state.showWhiteTransferModale})}} open={this.state.showWhiteTransferModale} classNames={{modal: "zoomModalCart"}}
                 center>
            <div>
              <div dangerouslySetInnerHTML={{__html: this.state.changeColorSericoatWTxt}}></div>
            </div>
          </Modal>
          <Modal onClose={() => {this.setState({showCETransferModale: !this.state.showCETransferModale})}} open={this.state.showCETransferModale} classNames={{modal: "zoomModalCart"}}
                 center>
            <div>
              <div dangerouslySetInnerHTML={{__html: this.state.changeColorSericoatCEtxt}}></div>
            </div>
          </Modal>
        </div>
      </>
    );
  }
}
export default withTranslation('common')(withHostApi(ColorsTextile));
